<div class="container-fluid mb-4">
  <h4 class="my-4 fw-bold">
    Información Financiera Contratante/Empleado y Origen de Fondos
  </h4>
  <form [formGroup]="formFinanciero">
    <!-- ========================= -->
    <!-- TABLA DE RANGOS -->
    <!-- ========================= -->
    <div class="table-responsive">
      <table class="table table-bordered align-middle text-center">
        <thead class="table-custom-header">
          <tr>
            <th>Rango</th>
            <th>Ingresos mensuales</th>
            <th>Egresos mensuales</th>
            <th>Otros ingresos</th>
          </tr>
        </thead>

        <tbody formArrayName="rangos">
          <tr
            *ngFor="let row of rows.controls; let i = index"
            [formGroupName]="i"
          >
            <td class="text-start">{{ row.value.rango }}</td>

            <td>
              <mat-checkbox
                color="primary"
                formControlName="ingresos"
                (change)="onCheckChange(i, 'ingresos')"
              ></mat-checkbox>
            </td>

            <td>
              <mat-checkbox
                color="primary"
                formControlName="egresos"
                (change)="onCheckChange(i, 'egresos')"
              ></mat-checkbox>
            </td>

            <td>
              <mat-checkbox
                color="primary"
                formControlName="otros"
                (change)="onCheckChange(i, 'otros')"
              ></mat-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ========================= -->
    <!-- ERRORES DE RANGOS -->
    <!-- ========================= -->
     <div class="text-danger mt-2" *ngIf="rows.touched && ingresosRequired">
      Debe seleccionar un rango para ingresos mensuales
    </div>
    <div class="text-danger" *ngIf="rows.touched && egresosRequired">
      Debe seleccionar un rango para egresos mensuales
    </div>
    <!-- ========================= -->
    <!-- ACTIVOS Y PASIVOS -->
    <!-- ========================= -->
    <div class="row mt-4">
      <div class="col-md-6">
        <mat-form-field class="w-100">
          <mat-label>Valor Activos o Posesiones</mat-label>
          <input
            matInput
            type="text"
            formControlName="activos"
            placeholder="$"
            appCurrencyCop
            inputmode="numeric"
            pattern="[0-9]*"
          />
          <mat-error *ngIf="formFinanciero.get('activos')?.invalid">
            El campo es obligatorio.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field class="w-100">
          <mat-label>Valor Pasivos o Deudas</mat-label>
          <input
            matInput
            type="text"
            formControlName="pasivos"
            placeholder="$"
            appCurrencyCop
            inputmode="numeric"
            pattern="[0-9]*"
          />
          <mat-error *ngIf="formFinanciero.get('pasivos')?.invalid">
            El campo es obligatorio.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- ========================= -->
    <!-- ORIGEN DE FONDOS -->
    <!-- ========================= -->
    <div class="card mt-4">
      <div class="card-header card-custom-header fw-bold">
        Declaración voluntaria de Origen de Fondos / Ingresos
      </div>

      <div class="card-body" formGroupName="origenFondos">
        <div class="row">
          <div class="col-md-6">
            <mat-checkbox color="primary" formControlName="ahorros"
              >Ahorros</mat-checkbox
            ><br />
            <mat-checkbox color="primary" formControlName="salarios"
              >Salarios</mat-checkbox
            ><br />
            <mat-checkbox color="primary" formControlName="honorarios"
              >Honorarios</mat-checkbox
            ><br />
            <mat-checkbox color="primary" formControlName="otros"
              >Otros</mat-checkbox
            >
          </div>

          <div class="col-md-6">
            <mat-checkbox color="primary" formControlName="ventaActivos">
              Venta de Activos </mat-checkbox
            ><br />
            <mat-checkbox color="primary" formControlName="arrendamientos">
              Arrendamientos </mat-checkbox
            ><br />
            <mat-checkbox color="primary" formControlName="rendimientos">
              Rendimientos Financieros </mat-checkbox
            ><br />
            <mat-checkbox color="primary" formControlName="comisiones">
              Comisiones
            </mat-checkbox>
          </div>
        </div>

        <!-- OTROS -->
        <div class="row mt-3" *ngIf="origenFondos.get('otros')?.value">
          <div class="col-md-6">
            <mat-form-field class="w-100">
              <mat-label>¿Cuál?</mat-label>
              <input matInput formControlName="otrosDescripcion" />
              <mat-error *ngIf="origenFondos.get('otrosDescripcion')?.invalid">
                Debe especificar el origen
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- ========================= -->
    <!-- DESCRIPCIÓN OTRAS FUENTES -->
    <!-- ========================= -->
    <div class="mt-4">
      <mat-form-field class="w-100">
        <mat-label>Descripción de Otras Fuentes de Ingresos</mat-label>

        <textarea
          matInput
          rows="2"
          formControlName="descripcionOtrasFuentes"
        ></textarea>

        <!-- CONTADOR -->
        <mat-hint align="end">
          {{
            formFinanciero.get("descripcionOtrasFuentes")?.value?.length || 0
          }}/200
        </mat-hint>

        <!-- ERROR POR EXCESO -->
        <mat-error
          *ngIf="
            formFinanciero.get('descripcionOtrasFuentes')?.hasError('maxlength')
          "
        >
          Ha excedido la cantidad máxima de 200 caracteres permitidos.
        </mat-error>
      </mat-form-field>
    </div>

    <!-- ========================= -->
    <!-- OPERACIONES MONEDA EXTRANJERA -->
    <!-- ========================= -->
    <div class="card mt-4" formGroupName="monedaExtranjera">
      <div class="card-header card-custom-header fw-bold">
        Operaciones en Moneda Extranjera
      </div>

      <div class="card-body">
        <div>
          ¿Usted realiza transacciones en moneda extranjera?
          <mat-radio-group formControlName="realizaOperaciones" class="ms-3">
            <mat-radio-button color="primary" [value]="true"
              >Sí</mat-radio-button
            >
            <mat-radio-button color="primary" [value]="false" class="ms-3"
              >No</mat-radio-button
            >
          </mat-radio-group>
          <div
          class="text-danger mt-1"
          *ngIf="
            formFinanciero.get('monedaExtranjera.realizaOperaciones')?.invalid &&
            formFinanciero.get('monedaExtranjera.realizaOperaciones')?.touched
          "
        >
          Debe seleccionar una opción (Sí o No)
        </div>
        </div>
        <div
          *ngIf="
            formFinanciero.get('monedaExtranjera.realizaOperaciones')?.value
          "
        >
          <div class="row">
            <div class="col-md-4">
              <mat-checkbox color="primary" formControlName="exportaciones"
                >Exportaciones</mat-checkbox
              ><br />
              <mat-checkbox color="primary" formControlName="importaciones"
                >Importaciones</mat-checkbox
              >
            </div>

            <div class="col-md-4">
              <mat-checkbox color="primary" formControlName="transferencias"
                >Transferencias</mat-checkbox
              ><br />
              <mat-checkbox color="primary" formControlName="pagosServicios"
                >Pago de Servicios</mat-checkbox
              >
            </div>

            <div class="col-md-4">
              <mat-checkbox color="primary" formControlName="inversiones"
                >Inversiones</mat-checkbox
              ><br />
              <mat-checkbox color="primary" formControlName="prestamos"
                >Préstamos</mat-checkbox
              ><br />
              <mat-checkbox color="primary" formControlName="giros"
                >Giros</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MONEDA -->
     <div
      class="text-danger mt-2"
      *ngIf="formFinanciero.get('monedaExtranjera')?.touched && operacionMonedaRequired"
    >
      Debe seleccionar al menos una operación en moneda extranjera
    </div>
    <!-- ========================= -->
    <!-- IDENTIFICACIÓN PEP -->
    <!-- ========================= -->
    <div class="card mt-4" formGroupName="pep">
      <div class="card-header card-custom-header fw-bold">
        Identificación de Persona Expuesta Políticamente (PEP)
      </div>

      <div class="card-body">
        <!-- 1️⃣ ES PEP -->
        <div class="row align-items-center mb-3">
          <div>
            ¿Es una persona políticamente expuesta según la legislación vigente?
            <mat-radio-group formControlName="esPep">
              <mat-radio-button color="primary" [value]="true"
                >Sí</mat-radio-button
              >
              <mat-radio-button color="primary" [value]="false" class="ms-3"
                >No</mat-radio-button
              >
            </mat-radio-group>
            <div
              class="text-danger mt-1"
              *ngIf="
                formFinanciero.get('pep.esPep')?.invalid &&
                formFinanciero.get('pep.esPep')?.touched
              "
            >
              Debe seleccionar una opción (Sí o No)
            </div>
          </div>
        </div>

        <div class="row" *ngIf="formFinanciero.get('pep.esPep')?.value">
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Cargo</mat-label>
              <input matInput formControlName="cargo" />
              <mat-error
                *ngIf="formFinanciero.get('pep.cargo')?.hasError('required')"
              >
                El campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Fecha de Inicio</mat-label>
              <input
                matInput
                [matDatepicker]="pickerInicio"
                formControlName="fechaInicio"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerInicio"
              ></mat-datepicker-toggle>

              <mat-datepicker #pickerInicio></mat-datepicker>
              <mat-error
                *ngIf="
                  formFinanciero.get('pep.fechaInicio')?.hasError('required') &&
                  !formFinanciero
                    .get('pep.fechaInicio')
                    ?.hasError('matDatepickerParse')
                "
              >
                El campo es obligatorio
              </mat-error>

              <mat-error
                *ngIf="
                  formFinanciero
                    .get('pep.fechaInicio')
                    ?.hasError('matDatepickerParse')
                "
              >
                Fecha inválida (YYYY/MM/DD)
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Fecha Fin</mat-label>
              <input
                matInput
                [matDatepicker]="pickerFin"
                formControlName="fechaFin"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerFin"
              ></mat-datepicker-toggle>

              <mat-datepicker #pickerFin></mat-datepicker>
              <mat-error
                *ngIf="
                  formFinanciero.get('pep.fechaFin')?.hasError('required') &&
                  !formFinanciero
                    .get('pep.fechaFin')
                    ?.hasError('matDatepickerParse')
                "
              >
                El campo es obligatorio
              </mat-error>
              <mat-error
                *ngIf="
                  formFinanciero
                    .get('pep.fechaFin')
                    ?.hasError('matDatepickerParse')
                "
              >
                Fecha inválida (YYYY/MM/DD)
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <hr />

        <!-- 2️⃣ REPRESENTA ONG / OIG -->
        <div class="row align-items-center mb-3">
          <div>
            ¿Representa legalmente alguna Organización Internacional (ONG –
            OIG)?
            <mat-radio-group formControlName="representaONG">
              <mat-radio-button color="primary" [value]="true"
                >Sí</mat-radio-button
              >
              <mat-radio-button color="primary" [value]="false" class="ms-3"
                >No</mat-radio-button
              >
            </mat-radio-group>
            <div
            class="text-danger mt-1"
            *ngIf="
              formFinanciero.get('pep.representaONG')?.invalid &&
              formFinanciero.get('pep.representaONG')?.touched
            "
          >
            Debe seleccionar una opción (Sí o No)
          </div>
          </div>
        </div>

        <div class="row" *ngIf="formFinanciero.get('pep.representaONG')?.value">
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Cargo</mat-label>
              <input matInput formControlName="cargoONG" />
              <mat-error
                *ngIf="formFinanciero.get('pep.cargoONG')?.hasError('required')"
              >
                El campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Fecha de Inicio</mat-label>
              <input
                matInput
                [matDatepicker]="pickerInicioONG"
                formControlName="fechaInicioONG"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerInicioONG"
              ></mat-datepicker-toggle>

              <mat-datepicker #pickerInicioONG></mat-datepicker>
              <mat-error
                *ngIf="
                  formFinanciero
                    .get('pep.fechaInicioONG')
                    ?.hasError('required') &&
                  !formFinanciero
                    .get('pep.fechaInicioONG')
                    ?.hasError('matDatepickerParse')
                "
              >
                El campo es obligatorio
              </mat-error>

              <mat-error
                *ngIf="
                  formFinanciero
                    .get('pep.fechaInicioONG')
                    ?.hasError('matDatepickerParse')
                "
              >
                Fecha inválida (YYYY/MM/DD)
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <!-- <mat-form-field class="w-100">
              <mat-label>Fecha Fin</mat-label>
              <input matInput type="date" formControlName="fechaFinONG" />
              <mat-error
                *ngIf="
                  formFinanciero.get('pep.fechaFinONG')?.hasError('required')
                "
              >
                El campo es obligatorio
              </mat-error>
            </mat-form-field> -->
            <mat-form-field class="w-100">
              <mat-label>Fecha fin</mat-label>
              <input
                matInput
                [matDatepicker]="pickerFinONG"
                formControlName="fechaFinONG"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerFinONG"
              ></mat-datepicker-toggle>

              <mat-datepicker #pickerFinONG></mat-datepicker>
              <mat-error
                *ngIf="
                  formFinanciero.get('pep.fechaFinONG')?.hasError('required') &&
                  !formFinanciero
                    .get('pep.fechaFinONG')
                    ?.hasError('matDatepickerParse')
                "
              >
                El campo es obligatorio
              </mat-error>

              <mat-error
                *ngIf="
                  formFinanciero
                    .get('pep.fechaFinONG')
                    ?.hasError('matDatepickerParse')
                "
              >
                Fecha inválida (YYYY/MM/DD)
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <hr />

        <!-- 3️⃣ VÍNCULO CON PEP -->
        <div class="row align-items-center">
          <div>
            ¿Existe algún vínculo entre usted y alguna persona expuesta
            políticamente?
            <mat-radio-group formControlName="vinculoPep">
              <mat-radio-button color="primary" [value]="true"
                >Sí</mat-radio-button
              >
              <mat-radio-button color="primary" [value]="false" class="ms-3"
                >No</mat-radio-button
              >
            </mat-radio-group>
            <div
            class="text-danger mt-1"
            *ngIf="
              formFinanciero.get('pep.vinculoPep')?.invalid &&
              formFinanciero.get('pep.vinculoPep')?.touched
            "
          >
            Debe seleccionar una opción (Sí o No)
          </div>
          </div>
        </div>

        <div class="row" *ngIf="formFinanciero.get('pep.vinculoPep')?.value">
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombrePep" />
              <mat-error
                *ngIf="
                  formFinanciero.get('pep.nombrePep')?.hasError('required')
                "
              >
                El campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Cargo</mat-label>
              <input matInput formControlName="cargoPep" />
              <mat-error
                *ngIf="formFinanciero.get('pep.cargoPep')?.hasError('required')"
              >
                El campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field class="w-100">
              <mat-label>Parentesco</mat-label>
              <input matInput formControlName="parentesco" />
              <mat-error
                *ngIf="
                  formFinanciero.get('pep.parentesco')?.hasError('required')
                "
              >
                El campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
